<mat-card  class="empty-state">
  <mat-card-content>
    <mat-icon color="primary" class="empty-icon">search_off</mat-icon>

    <h2>No results found</h2>
    <p>Try adjusting your search criteria or entering another keyword.</p>
  </mat-card-content>
</mat-card>
